<template>
    <slot :open-modal="openBestPriceModal" />

    <dialog id="bestPriceModal" ref="bestPriceModal" class="modal">
        <div class="modal-box max-w-[685px]">
            <LazyProductDetailBestPriceForm v-if="initialized" />
        </div>
        <form method="dialog" class="modal-backdrop">
            <button type="submit">
                {{ $t('bestPrice.modalClose') }}
            </button>
        </form>
    </dialog>
</template>

<script setup lang="ts">
const bestPriceModal = ref<HTMLDialogElement | null>()
const initialized = ref(false)

function openBestPriceModal () {
    bestPriceModal?.value?.showModal()
    initialized.value = true
}

function closeBestPriceModal () {
    bestPriceModal?.value?.close()
}

/*
 * Watch form was submitted
 */
const formSubmitSuccess = ref(false)
function setFormSuccess (state: boolean): void {
    formSubmitSuccess.value = state
}

provide('submitSuccess', setFormSuccess)

watch(formSubmitSuccess, (value, oldValue) => {
    if (oldValue === false && value === true) {
        closeBestPriceModal()
    }
})
</script>
